export default {
  START: 'start',
  STOP: 'stop',
  START_PENDING: 'startPending'
};
